import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAuthorization } from "../../../services/config";
import client from "../../../services/config";
import { updateLoading } from "../loader";
import API_ROUTES from "../../../constants/apiRoutes";
import {
  ToastNotifyError,
  ToastNotifySuccess,
} from "../../../components/CommonComponents/Toast/ToastNotify";

const {
  V1: {
    GET_PROFILE,
    RECOMMENDED,
    CLOSET,
    GET_HOTELS,
    GET_CITYS,
    SIZE,
    CREATE_TRIP,
    GET_HOME_PAGE,
    GET_PRODUCTS,
    GET_DESIGNERS,
    GET_CATEGORIES,
    GET_SELLER_DETAILS,
    CUSTOMER_SUPPORT,
    SELLER_COLOURS,
    SELLER_SIZES,
    FAQ,
    NEWSLETTER,
    UPLOAD_IMAGE
  } = {},
} = API_ROUTES;

const createTrip = createAsyncThunk(
  "home/create",
  async (payload, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(CREATE_TRIP, payload);

      dispatch(updateLoading(false));

      if (!response?.data?.success) {
        ToastNotifySuccess(response?.data?.message);
      }

      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      ToastNotifyError(err?.message || "Error creating trip");
    }
  }
);

const updateTrip = createAsyncThunk(
  "home/update",
  async (payload, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.patch(
        `${CREATE_TRIP}${payload?.tripId}/`,
        payload?.tripPayload
      );

      dispatch(updateLoading(false));

      if (!response?.data?.success) {
        ToastNotifySuccess(response?.data?.message);
      }

      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      ToastNotifyError(err?.message || "Error creating trip");
    }
  }
);
const getTrip = createAsyncThunk(
  "home/gettrip",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(CREATE_TRIP);
      dispatch(updateLoading(false));

      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      ToastNotifyError(err?.message || "Error creating trip");
    }
  }
);

const getProfile = createAsyncThunk(
  "home/createProfile",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });

    try {
      dispatch(updateLoading(true));

      const response = await API.post(GET_PROFILE, payload);

      dispatch(updateLoading(false));

      if (!response?.payload?.status === 201) {
        return response;
      } else {
        return response;
      }
    } catch (err) {
      dispatch(updateLoading(false));
      return rejectWithValue(err?.response || err?.message);
    }
  }
);

const fetchHotels = createAsyncThunk(
  "home/hotels",
  async (cityId, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const url = cityId ? `${GET_HOTELS}?city=${cityId}` : GET_HOTELS;
      const response = await API.get(url);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const getSize = createAsyncThunk(
  "home/size",
  async (payload, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(
        SIZE.replace("[ID]", payload?.id) + payload.color
      );
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchCitys = createAsyncThunk(
  "home/citys",
  async (hotelId, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const url = hotelId ? `${GET_CITYS}?hotel=${hotelId}` : GET_CITYS;
      const response = await API.get(url);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchHomePage = createAsyncThunk(
  "home/homepage",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(GET_HOME_PAGE);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchProducts = createAsyncThunk(
  "home/products",
  async (params, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(`${GET_PRODUCTS}${params}`);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchRecommendedProducts = createAsyncThunk(
  "home/recommendedProducts",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(`${RECOMMENDED}`);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchProductDetails = createAsyncThunk(
  "home/productDetails",
  async (params, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(`${GET_PRODUCTS}${params}`);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchProfile = createAsyncThunk(
  "home/profile",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(GET_PROFILE);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);
const updateProfile = createAsyncThunk(
  "home/update-profile",
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.put(GET_PROFILE, data);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);
const updateRecoveryEmail = createAsyncThunk(
  "home/updateRecoveryEmail",
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.put(GET_PROFILE, data);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchCloset = createAsyncThunk(
  "home/closet",
  async (params, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true, isSessionKey: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(`${CLOSET}${params}`);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchDesigners = createAsyncThunk(
  "home/browse",
  async (params, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(`${GET_DESIGNERS}${params}`);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchCategories = createAsyncThunk(
  "home/categories",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(GET_CATEGORIES);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchSellerDetails = createAsyncThunk(
  "home/seller-details",
  async (params, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(`${GET_SELLER_DETAILS}${params}`);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const DeleteAccount = createAsyncThunk(
  "home/DeleteAccount",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.delete(GET_PROFILE);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);
const fetchSupportInformation = createAsyncThunk(
  "home/customerSupport",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(CUSTOMER_SUPPORT);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchColours = createAsyncThunk(
  "home/seller-colours",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(SELLER_COLOURS);
 
      return response?.data;
    } catch (err) {
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchFaq = createAsyncThunk(
  "home/faq",
  async (searchTerm, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(FAQ + `?search=${searchTerm}`);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchSizes = createAsyncThunk(
  "home/seller-sizes",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(SELLER_SIZES);
 
      return response?.data;
    } catch (err) {
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchNewsletter = createAsyncThunk( 
  "newsletter", 
  async (data, { dispatch, getState }) => { 
    const API = getAuthorization(getState, dispatch,); 
    try { 
      dispatch(updateLoading(true)); 
      const response = await API.post(NEWSLETTER, data); 
      dispatch(updateLoading(false)); 
      return response?.data; 
    } catch (err) { 
      dispatch(updateLoading(false)); 
      return err; 
    } 
  } 
);

const uploadImage = createAsyncThunk(
  "home/uploadImage",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(UPLOAD_IMAGE, "");
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      ToastNotifyError(err?.message || "Error uploading image");
      return err;
    }
  }
);

const uploadImageToS3 = createAsyncThunk(
  "home/uploadImageToS3",
  async ({ uploadUrl, file }, { dispatch }) => {
    const API = client({});
    try {
      dispatch(updateLoading(true));
      const response = await API.put(uploadUrl, file, {
        headers: {
          "Content-Type": file.type,
        },
      });
      return response;
    } catch (err) {
      ToastNotifyError(err?.message || "Error uploading image to S3");
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

export {
  fetchCloset,
  fetchHotels,
  fetchRecommendedProducts,
  getSize,
  updateTrip,
  fetchCitys,
  createTrip,
  fetchHomePage,
  fetchProducts,
  fetchDesigners,
  fetchCategories,
  fetchSellerDetails,
  fetchProfile,
  getProfile,
  fetchProductDetails,
  getTrip,
  updateProfile,
  updateRecoveryEmail,
  DeleteAccount,
  fetchSupportInformation,
  fetchColours,
  fetchSizes,
  fetchFaq,
  fetchNewsletter,
  uploadImage,
  uploadImageToS3
};
